import React from "react";

const AboutCompany = () => {
  return (
    <>
      <div className="about-details-page pt-140 pb-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="about-details-info pr-65">
                <div className="tp-section-wrapper">
                  <span className="tp-section-subtitle mb-25">
                    About our Company
                  </span>
                  <h2 className="tp-pt-size mb-40">
                    Leading With Limitless Ambition
                  </h2>
                </div>
                <div className="about-tb-content">
                  <nav>
                    <div className="nav mb-30" id="nav-tab" role="tablist">
                      <button
                        className="nav-links active"
                        id="mission"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-mission"
                        type="button"
                        role="tab"
                        aria-controls="nav-mission"
                        aria-selected="true"
                      >
                        Our Mission
                      </button>

                      <button
                        className="nav-links"
                        id="nav-vission-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-vission"
                        type="button"
                        role="tab"
                        aria-controls="nav-vission"
                        aria-selected="false"
                      >
                        Our Vission
                      </button>
                      <button
                        className="nav-links"
                        id="nav-value-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-value"
                        type="button"
                        role="tab"
                        aria-controls="nav-value"
                        aria-selected="false"
                      >
                        Our Value
                      </button>
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="nav-mission"
                      role="tabpanel"
                      aria-labelledby="nav-mission"
                    >
                      <p>
                        To set a new benchmark in the elevator industry by
                        providing the best global engineering solutions for
                        vertical transportation under the LUMETIQ Elevators
                        brand.
                      </p>

                      <p>
                        To manufacture, install, and maintain a wide range of
                        elevators, escalators, platform lifts, and accessibility
                        equipment.
                      </p>
                      <p>
                        To ensure customer satisfaction through comfortable,
                        safe, and innovative lift solutions tailored to diverse
                        environmental and power conditions.
                      </p>
                      <p>
                        To foster a vibrant, performance-driven work environment
                        with opportunities for growth and continuous
                        improvement.
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="nav-vission"
                      role="tabpanel"
                      aria-labelledby="nav-vission-tab"
                    >
                      <p>
                      At LUMETIQ Elevators, we envision a future where vertical mobility is seamless, intelligent, and inclusive — empowering people to move with confidence and comfort in every space, from residential buildings to iconic skyscrapers.
                      </p>

                      <p>
                      Delivering cutting-edge lift solutions that blend innovation, safety, and sustainability.
                      </p>
                      <p>
                      Setting new standards in engineering excellence, leveraging global expertise and locally-driven execution.
                      </p>
                      <p>
                      Transforming the elevator experience through smart technology, energy-efficient systems, and user-focused designs.
                      </p>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="nav-value"
                      role="tabpanel"
                      aria-labelledby="nav-value-tab"
                    >
                    <p>
                        <strong>Customer First:</strong>  We prioritize our customers' needs, delivering unparalleled safety, comfort, and satisfaction in every ride.
                      </p>
                      <p>
                        <strong>Innovation & Quality:</strong> We pursue excellence through continuous research, advanced engineering, and cutting-edge technology to provide reliable and future-ready solutions.
                      </p>
                      <p>
                        <strong>Integrity & Reliability:</strong>We uphold the highest standards of transparency, honesty, and professionalism in all aspects of our business.
                      </p>
                      <p>
                        <strong>Service Excellence:</strong> We are committed to providing skilled, efficient, and timely installation and maintenance services that exceed expectations.
                      </p>
                      <p>
                        <strong>Accessibility for All:</strong> We champion inclusivity by designing lift solutions that ensure safe and easy access for people with physical challenges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end">
              <div className="tp-about-img-box p-relative d-inline-block mb-30">
                <div className="about-page-img">
                  <img src="assets/img/about/about-page.png" alt="" />
                </div>
                <div className="dots-img">
                  <img src="assets/img/about/dot.jpg" alt="" />
                </div>
               {
                window.innerWidth<=576? <div style={{height:"250px",width:"300px",position:"absolute",left:"25px",top:"10px"}}   className="about-info-box d-flex flex-column justify-content-center text-center">
                <h3 style={{fontSize:"50px"}} className="box-title">15 </h3>
                <h4 className="box-subtitle">
                  Year of <br />
                  Experience
                </h4>
              </div>: <div   className="about-info-box d-flex flex-column justify-content-center text-center">
                <h3 className="box-title">15 </h3>
                <h4 className="box-subtitle">
                  Year of <br />
                  Experience
                </h4>
              </div>
               }
              </div>
            </div>
          </div>
        </div>

        {/* second  */}
        <div className="container">
          <div className="row align-items-center">
            {/* Image Column FIRST */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="tp-about-img-box p-relative d-inline-block">
                <div className="about-page-img">
                  <img
                    style={{ height:window.innerWidth<=576?'300px': "556px", width: "600px" }}
                    src="assets/img/about/image.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
                <div className="dots-img">
                  <img src="" alt="" className="img-fluid" />
                </div>
              </div>
            </div>

            {/* Text Column SECOND */}
            <div className="col-lg-6">
              <div className="about-details-info pr-lg-5">
                <div className="tp-section-wrapper">
                  <span className="tp-section-subtitle mb-25">
                    About our Company
                  </span>
                  <h2 className="tp-pt-size mb-40">
                    Leading With Limitless Ambition
                  </h2>
                </div>
                <div className="about-tb-content">
                  <nav>
                    <div className="nav mb-30" id="nav-tab-2" role="tablist">
                      <button
                        className="nav-links active"
                        id="mission-tab-2"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-mission-2"
                        type="button"
                        role="tab"
                        aria-controls="nav-mission-2"
                        aria-selected="true"
                      >
                        Our Mission
                      </button>
                      <button
                        className="nav-links"
                        id="vission-tab-2"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-vission-2"
                        type="button"
                        role="tab"
                        aria-controls="nav-vission-2"
                        aria-selected="false"
                      >
                        Our Vission
                      </button>
                      <button
                        className="nav-links"
                        id="value-tab-2"
                        data-bs-toggle="tab"
                        data-bs-target="#nav-value-2"
                        type="button"
                        role="tab"
                        aria-controls="nav-value-2"
                        aria-selected="false"
                      >
                        Our Value
                      </button>
                    </div>
                  </nav>

                  <div className="tab-content" id="nav-tabContent-2">
                    {/* Mission Tab */}
                    <div
                      className="tab-pane fade show active"
                      id="nav-mission-2"
                      role="tabpanel"
                      aria-labelledby="mission-tab-2"
                    >
                      <p>
                      At LUMETIQ Elevators, our mission is to set a new benchmark in the elevator industry by delivering world-class engineering solutions for vertical transportation.
                      </p>
                      <p>
                      We are dedicated to the design, manufacturing, installation, and maintenance of a comprehensive range of elevators, escalators, platform lifts, and accessibility systems — all crafted with precision and reliability
                      </p>
                      <p>
                      Our goal is to ensure complete customer satisfaction through solutions that are safe, comfortable, and technologically advanced, tailored to meet diverse environmental and power conditions across the globe.
                      </p>
                      <p>
                      We are equally committed to nurturing a vibrant, performance-driven culture that encourages professional growth, continuous improvement, and shared success at every level of the organization.
                      </p>
                    </div>

                    {/* Vision Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-vission-2"
                      role="tabpanel"
                      aria-labelledby="vission-tab-2"
                    >
                      <p>
                      Headquartered in the vibrant industrial hub of Rajkot, a dynamic and fast-growing commercial center, LUMETIQ aims to drive excellence and set new standards in vertical transportation across the nation.
                      </p>
                      <p>
                      To be recognized as India’s leading lift solution provider by delivering a comprehensive range of high-quality, reliable, and innovative elevator products and services tailored to the needs of the construction, architecture, and built environment sectors.
                      </p>
                    </div>

                    {/* Value Tab */}
                    <div
                      className="tab-pane fade"
                      id="nav-value-2"
                      role="tabpanel"
                      aria-labelledby="value-tab-2"
                    >
                      <p>
                        <strong>Customer First:</strong>  We prioritize our customers' needs, delivering unparalleled safety, comfort, and satisfaction in every ride.
                      </p>
                      <p>
                        <strong>Innovation & Quality:</strong> We pursue excellence through continuous research, advanced engineering, and cutting-edge technology to provide reliable and future-ready solutions.
                      </p>
                      <p>
                        <strong>Integrity & Reliability:</strong>We uphold the highest standards of transparency, honesty, and professionalism in all aspects of our business.
                      </p>
                      <p>
                        <strong>Service Excellence:</strong> We are committed to providing skilled, efficient, and timely installation and maintenance services that exceed expectations.
                      </p>
                      <p>
                        <strong>Accessibility for All:</strong> We champion inclusivity by designing lift solutions that ensure safe and easy access for people with physical challenges.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutCompany;
